import { ISearchResource } from '../../factories/search/search';
export class storeSearchController {
  searchResult;
  result: boolean;
  showLockup: boolean = false;
  Vendors: any;
  ProductTypes: any;
  categorys: any;
  manufactures: any;
  loading: boolean;
  products: any;
  searchKeyword: any;
  BaseUrlPage: any;
  constructor(
    private $mPath,
    private $window,
    private $search: ISearchResource,
    private $timeout,
    private MyConstant,
    private $q,
    private $rootScope
  ) {
    'ngInject';

    $mPath.get().then(response => {
      this.BaseUrlPage = response;
    });
  }
  $onInit() {
    this.$rootScope.$on('clickOtherSide', () => {
      this.showLockup = false;
    });
    this.$rootScope.$emit('clickOtherSide');
  }
  isEnter($event) {
    var keyCode = $event.which || $event.keyCode;
    if (keyCode === 13) {
      this.redirectToResult();
    } else if (keyCode === 27) {
      this.showLockup = false;
    }
  }
  isEscape($event) {
    var keyCode = $event.which || $event.keyCode;
  }

  redirectToResult() {
    this.searchKeyword = this.searchKeyword ? this.searchKeyword : '';
    if (this.searchKeyword.length > 2) {
      this.$window.location.href =
        this.BaseUrlPage.StoreSearchResult +
        '/keyword/' +
        this.searchKeyword +
        '/';
    }
  }

  changeKeyword(keyword) {
    if (this.searchKeyword && this.searchKeyword.length > 2) {
      this.loading = true;
      this.result = false;
      this.showLockup = true;
      if (this.searchResult) {
        this.searchResult.$cancelRequest();
      }
      this.searchResult = this.$search.get(
        { FilterText: this.searchKeyword.toString() },
        result => {
          this.result = true;
          this.loading = false;
          this.products = result.Products;
          this.manufactures = result.ManufacturesHierarchy;
          this.categorys = result.Categories;
          this.ProductTypes = result.ProductTypes;
          this.Vendors = result.Vendors;
        }
      );
    } else {
      this.showLockup = false;
    }
  }
  onShowLockup() {
    this.$window.onclick = event => {
      var clickedElement = event.target;
      var elementClasses = clickedElement.classList;
      var clickedOnSearchDrawer = elementClasses.contains('searchArea');
      if (!clickedOnSearchDrawer) {
        // if (this.searchResult) {
        //     this.searchResult.$cancelRequest()
        // }
        this.$rootScope.$emit('clickOtherSide');
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/components/store-search/store-search.controller.ts